module.exports = __webpack_public_path__ + "static/media/flag-catalonia.05c70913.svg";